export default __webpack_public_path__ + "static/media/logo_blue.1b9683b3.png";